export const STATUS_STEPS = [
  { key: "order_placed", label: "Order Placed" },
  { key: "payment_confirmed", label: "Payment Confirmed" },
  { key: "documents_pending", label: "Documents Pending" },
  { key: "documents_received", label: "Documents Received" },
  { key: "under_review", label: "Under Review" },
  { key: "processing", label: "Processing" },
  { key: "submitted", label: "Submitted" },
  { key: "completed", label: "Completed" },
];

export const STATUS_LABEL = Object.fromEntries(
  STATUS_STEPS.map((s) => [s.key, s.label])
);
STATUS_LABEL.cancelled = "Cancelled";

export const PAYMENT_BADGE = {
  pending: "badge-warn",
  paid: "badge-success",
  failed: "badge-error",
  refunded: "badge-muted",
};

export const STATUS_BADGE = {
  order_placed: "badge-muted",
  payment_confirmed: "badge-info",
  documents_pending: "badge-warn",
  documents_received: "badge-info",
  under_review: "badge-info",
  processing: "badge-info",
  submitted: "badge-info",
  completed: "badge-success",
  cancelled: "badge-error",
};

export function stepIndex(key) {
  const i = STATUS_STEPS.findIndex((s) => s.key === key);
  return i === -1 ? 0 : i;
}
